import type { FeatureNames } from "./feature-names";

/** European Portuguese names of the staff features and settings categories (see features.fr.ts). */
export const featuresPt: FeatureNames = {
  features: {
    SEARCH_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Pesquisar contas",
    VIEW_ACCOUNTS_STAFF_FEATURE_ENABLEMENT: "Ver uma conta",
    REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Mostrar um número",
    EDIT_CUSTOMER_SETTINGS_STAFF_FEATURE_ENABLEMENT: "Alterar as definições de um cliente",
    CLAIM_CASES_STAFF_FEATURE_ENABLEMENT: "Assumir processos",
    REASSIGN_CASES_STAFF_FEATURE_ENABLEMENT: "Reatribuir processos",
    ACT_ON_BEHALF_STAFF_FEATURE_ENABLEMENT: "Agir em nome de um cliente",
    CORRECT_ACCOUNT_DETAILS_STAFF_FEATURE_ENABLEMENT: "Corrigir os dados de uma conta",
    REVIEW_VERIFICATIONS_STAFF_FEATURE_ENABLEMENT: "Analisar as verificações",
    VIEW_ID_IMAGES_STAFF_FEATURE_ENABLEMENT: "Ver as imagens de identidade",
    APPROVE_PROS_STAFF_FEATURE_ENABLEMENT: "Aprovar profissionais",
    VIEW_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Ver os pagamentos",
    ISSUE_REFUNDS_STAFF_FEATURE_ENABLEMENT: "Reembolsar",
    ISSUE_CREDITS_STAFF_FEATURE_ENABLEMENT: "Conceder um crédito",
    WAIVE_FEES_STAFF_FEATURE_ENABLEMENT: "Anular taxas",
    MARK_PAYMENTS_PAID_STAFF_FEATURE_ENABLEMENT: "Marcar um pagamento como pago",
    MANAGE_PLAN_PRICES_STAFF_FEATURE_ENABLEMENT: "Definir os preços dos planos",
    RUN_PROMOS_STAFF_FEATURE_ENABLEMENT: "Lançar promoções",
    OFFER_DISCOUNTS_STAFF_FEATURE_ENABLEMENT: "Conceder descontos",
    MANAGE_SUBSCRIPTIONS_STAFF_FEATURE_ENABLEMENT: "Prolongar ou terminar uma assinatura",
    APPROVE_PAYMENT_REQUESTS_STAFF_FEATURE_ENABLEMENT: "Autorizar acima do limite",
    RECONCILE_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Reconciliar os pagamentos",
    EXPORT_PAYMENTS_STAFF_FEATURE_ENABLEMENT: "Exportar",
    HANDLE_REPORTS_STAFF_FEATURE_ENABLEMENT: "Tratar as denúncias",
    SET_REPORT_SEVERITY_STAFF_FEATURE_ENABLEMENT: "Definir a gravidade de uma denúncia",
    SUSPEND_PENDING_INVESTIGATION_STAFF_FEATURE_ENABLEMENT: "Suspensão provisória",
    ISSUE_VERDICTS_STAFF_FEATURE_ENABLEMENT: "Emitir um veredicto",
    BAN_PERMANENTLY_STAFF_FEATURE_ENABLEMENT: "Banir definitivamente",
    HANDLE_APPEALS_STAFF_FEATURE_ENABLEMENT: "Tratar os recursos",
    REFER_TO_POLICE_STAFF_FEATURE_ENABLEMENT: "Encaminhar para a polícia",
    SHARE_DATA_WITH_POLICE_STAFF_FEATURE_ENABLEMENT: "Partilhar dados com a polícia",
    PLACE_LEGAL_HOLDS_STAFF_FEATURE_ENABLEMENT: "Preservar provas",
    MODERATE_REVIEWS_STAFF_FEATURE_ENABLEMENT: "Moderar as avaliações",
    SEND_SMS_STAFF_FEATURE_ENABLEMENT: "Enviar um SMS",
    SEND_BULK_SMS_STAFF_FEATURE_ENABLEMENT: "Enviar SMS em massa",
    EDIT_SMS_TEMPLATES_STAFF_FEATURE_ENABLEMENT: "Alterar os modelos de SMS",
    MANAGE_APP_FEATURES_STAFF_FEATURE_ENABLEMENT: "Gerir as funcionalidades da app",
    EDIT_RULES_STAFF_FEATURE_ENABLEMENT: "Alterar as regras",
    EDIT_PRICING_STAFF_FEATURE_ENABLEMENT: "Alterar os preços",
    EDIT_CATEGORIES_STAFF_FEATURE_ENABLEMENT: "Alterar os ofícios",
    INVITE_STAFF_STAFF_FEATURE_ENABLEMENT: "Convidar para a equipa",
    DEACTIVATE_STAFF_STAFF_FEATURE_ENABLEMENT: "Desativar um membro",
    END_STAFF_SESSIONS_STAFF_FEATURE_ENABLEMENT: "Terminar as sessões",
    MANAGE_TEAMS_STAFF_FEATURE_ENABLEMENT: "Gerir equipas",
    MANAGE_ROLES_STAFF_FEATURE_ENABLEMENT: "Gerir as funções",
    MANAGE_ACTION_ENABLEMENTS_STAFF_FEATURE_ENABLEMENT: "Gerir ativações de ações",
    ASSIGN_ROLES_STAFF_FEATURE_ENABLEMENT: "Atribuir funções",
    MANAGE_LEADS_STAFF_FEATURE_ENABLEMENT: "Vendas e crescimento",
    VIEW_MARKETPLACE_STAFF_FEATURE_ENABLEMENT: "Operações do mercado",
    MANAGE_HUMAN_RESOURCES_STAFF_FEATURE_ENABLEMENT: "Recursos humanos",
    VIEW_AUDIT_LOG_STAFF_FEATURE_ENABLEMENT: "Consultar o registo de auditoria",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_FEATURE_ENABLEMENT: "Ver os valores sensíveis",
    VIEW_HEALTH_DASHBOARD_STAFF_FEATURE_ENABLEMENT: "Ver o painel",
  },
  /** The permissions that sit on those features (ADR-0019), by settingId. */
  permissions: {
    ISSUE_REFUND_STAFF_PERMISSION: "Emitir um reembolso",
    SETTLE_REFUND_STAFF_PERMISSION: "Liquidar um reembolso",
    ISSUE_CREDIT_STAFF_PERMISSION: "Emitir um crédito",
    WAIVE_FEE_STAFF_PERMISSION: "Anular uma taxa",
    REPLY_TO_CUSTOMER_STAFF_PERMISSION: "Responder a um cliente",
    CLOSE_CASE_STAFF_PERMISSION: "Encerrar um processo",
  },
  /** Customer features (Fonctionnalités), by settingId. */
  customerFeatures: {
    SEARCH_PROS_USER_FEATURE_ENABLEMENT: "Pesquisar profissionais",
    NEARBY_PROS_USER_FEATURE_ENABLEMENT: "Profissionais por perto",
    REQUEST_PRO_USER_FEATURE_ENABLEMENT: "Pedir um profissional",
    POST_OPEN_JOB_USER_FEATURE_ENABLEMENT: "Publicar um pedido aberto",
    JOB_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos num pedido",
    SELECT_QUOTE_USER_FEATURE_ENABLEMENT: "Escolher um orçamento",
    LEAVE_REVIEWS_USER_FEATURE_ENABLEMENT: "Deixar uma avaliação",
    REQUEST_CALLBACK_USER_FEATURE_ENABLEMENT: "Pedir que liguem de volta",
    SAVE_FAVORITE_PROS_USER_FEATURE_ENABLEMENT: "Profissionais favoritos",
    REBOOK_PRO_USER_FEATURE_ENABLEMENT: "Voltar a contratar um profissional",
    SHARE_PRO_PROFILE_USER_FEATURE_ENABLEMENT: "Partilhar o perfil de um profissional",
    SCHEDULE_JOB_USER_FEATURE_ENABLEMENT: "Agendar um pedido",
    URGENT_JOB_USER_FEATURE_ENABLEMENT: "Pedido urgente",
    BECOME_PRO_USER_FEATURE_ENABLEMENT: "Tornar-se profissional",
    LEAD_PREFERENCES_USER_FEATURE_ENABLEMENT: "Preferências de oportunidades",
    EDIT_RATES_USER_FEATURE_ENABLEMENT: "Alterar tarifas",
    BROWSE_OPEN_JOBS_USER_FEATURE_ENABLEMENT: "Ver pedidos abertos",
    QUOTE_JOBS_USER_FEATURE_ENABLEMENT: "Orçamentos para pedidos",
    PRO_SUBSCRIPTIONS_USER_FEATURE_ENABLEMENT: "Assinaturas de profissional",
    SUBMIT_VERIFICATION_USER_FEATURE_ENABLEMENT: "Enviar verificação",
    PAUSE_LEADS_USER_FEATURE_ENABLEMENT: "Pausar oportunidades",
    PORTFOLIO_PHOTOS_USER_FEATURE_ENABLEMENT: "Fotos de trabalhos",
    QUICK_REPLIES_USER_FEATURE_ENABLEMENT: "Respostas rápidas",
    ACTIVITY_PAGE_USER_FEATURE_ENABLEMENT: "Página de atividade",
    DECLARE_JOB_OUTCOME_USER_FEATURE_ENABLEMENT: "Declarar o desfecho de um pedido",
    LEAD_NOTIFICATIONS_USER_FEATURE_ENABLEMENT: "Oportunidades por notificação",
    SMS_LEADS_USER_FEATURE_ENABLEMENT: "Oportunidades por SMS",
    JOB_REMINDERS_USER_FEATURE_ENABLEMENT: "Lembretes de pedidos",
    SWITCH_MODE_USER_FEATURE_ENABLEMENT: "Alternar entre cliente e profissional",
    MESSAGING_USER_FEATURE_ENABLEMENT: "Mensagens",
    SEND_PHOTOS_USER_FEATURE_ENABLEMENT: "Enviar fotos",
    SHARE_LOCATION_USER_FEATURE_ENABLEMENT: "Partilhar localização",
    CHANGE_PHONE_USER_FEATURE_ENABLEMENT: "Alterar número de telefone",
    CHANGE_EMAIL_USER_FEATURE_ENABLEMENT: "Alterar email",
    CONTACT_US_USER_FEATURE_ENABLEMENT: "Contactar-nos",
    CREATE_CLIENT_PROFILE_USER_FEATURE_ENABLEMENT: "Criar um perfil de cliente",
    REPORT_USER_USER_FEATURE_ENABLEMENT: "Denunciar alguém",
    BLOCK_USER_USER_FEATURE_ENABLEMENT: "Bloquear alguém",
    APPEAL_DECISION_USER_FEATURE_ENABLEMENT: "Recorrer de uma decisão",
    SECURITY_ACTIVITY_USER_FEATURE_ENABLEMENT: "Atividade de segurança",
    REFER_FRIENDS_USER_FEATURE_ENABLEMENT: "Convidar amigos",
  },
  /** Every action, so the audit log names what was done instead of its id (#185). */
  actions: {
    SIGN_UP_USER_ACTION: "Inscrever-se",
    SIGN_IN_USER_ACTION: "Iniciar sessão",
    SIGN_OUT_USER_ACTION: "Terminar sessão",
    UPDATE_PERSONAL_INFO_USER_ACTION: "Atualizar os dados pessoais",
    CHANGE_PHONE_USER_ACTION: "Alterar o número de telefone",
    CHANGE_EMAIL_USER_ACTION: "Alterar o endereço de email",
    CHANGE_PASSWORD_USER_ACTION: "Alterar a palavra-passe",
    SWITCH_MODE_USER_ACTION: "Alternar entre cliente e profissional",
    CREATE_CLIENT_PROFILE_USER_ACTION: "Criar um perfil de cliente",
    UPDATE_SETTING_USER_ACTION: "Alterar uma definição",
    VIEW_SECURITY_ACTIVITY_USER_ACTION: "Ver a atividade de segurança",
    REFER_FRIEND_USER_ACTION: "Convidar um amigo",
    DELETE_ACCOUNT_USER_ACTION: "Eliminar a conta",
    BECOME_PRO_USER_ACTION: "Tornar-se profissional",
    SUBMIT_VERIFICATION_USER_ACTION: "Enviar um documento de identidade para verificação",
    UPDATE_PRO_PROFILE_USER_ACTION: "Atualizar o perfil de profissional",
    UPDATE_RATES_USER_ACTION: "Atualizar as tarifas",
    ADD_PORTFOLIO_PHOTO_USER_ACTION: "Adicionar uma foto de trabalhos",
    REMOVE_PORTFOLIO_PHOTO_USER_ACTION: "Remover uma foto de trabalhos",
    UPDATE_LEAD_PREFERENCES_USER_ACTION: "Atualizar as preferências de oportunidades",
    PAUSE_LEADS_USER_ACTION: "Pausar as oportunidades",
    RESUME_LEADS_USER_ACTION: "Retomar as oportunidades",
    VIEW_OPEN_JOBS_USER_ACTION: "Ver os pedidos abertos",
    VIEW_ACTIVITY_USER_ACTION: "Ver a atividade",
    REQUEST_PRO_USER_ACTION: "Pedir um profissional",
    POST_OPEN_JOB_USER_ACTION: "Publicar um pedido aberto",
    REBOOK_PRO_USER_ACTION: "Voltar a contratar um profissional",
    UPDATE_JOB_USER_ACTION: "Atualizar um pedido",
    ADD_JOB_PHOTOS_USER_ACTION: "Adicionar fotos a um pedido",
    SCHEDULE_JOB_USER_ACTION: "Agendar um pedido",
    MARK_JOB_URGENT_USER_ACTION: "Marcar um pedido como urgente",
    SELECT_QUOTE_USER_ACTION: "Escolher um orçamento",
    CANCEL_JOB_USER_ACTION: "Cancelar um pedido",
    SUBMIT_QUOTE_USER_ACTION: "Enviar um orçamento",
    UPDATE_QUOTE_USER_ACTION: "Atualizar um orçamento",
    WITHDRAW_QUOTE_USER_ACTION: "Retirar um orçamento",
    ACCEPT_JOB_USER_ACTION: "Aceitar um pedido",
    DECLINE_JOB_USER_ACTION: "Recusar um pedido",
    DECLARE_JOB_OUTCOME_USER_ACTION: "Declarar o desfecho de um pedido",
    SEARCH_PROS_USER_ACTION: "Pesquisar profissionais",
    SEARCH_PROS_NEARBY_USER_ACTION: "Pesquisar profissionais por perto",
    VIEW_PRO_PROFILE_USER_ACTION: "Ver o perfil de um profissional",
    SAVE_FAVORITE_PRO_USER_ACTION: "Guardar um profissional favorito",
    REMOVE_FAVORITE_PRO_USER_ACTION: "Remover um profissional favorito",
    SHARE_PRO_PROFILE_USER_ACTION: "Partilhar o perfil de um profissional",
    OPEN_CONVERSATION_USER_ACTION: "Abrir uma conversa",
    SEND_MESSAGE_USER_ACTION: "Enviar uma mensagem",
    SEND_PHOTO_USER_ACTION: "Enviar uma foto",
    SHARE_LOCATION_USER_ACTION: "Partilhar uma localização",
    READ_MESSAGES_USER_ACTION: "Ler as mensagens",
    SAVE_QUICK_REPLY_USER_ACTION: "Guardar uma resposta rápida",
    LEAVE_REVIEW_USER_ACTION: "Deixar uma avaliação",
    SUBSCRIBE_TO_PLAN_USER_ACTION: "Subscrever um plano",
    CANCEL_SUBSCRIPTION_USER_ACTION: "Cancelar a renovação",
    RESUME_SUBSCRIPTION_USER_ACTION: "Retomar a renovação",
    CHANGE_PLAN_USER_ACTION: "Mudar de plano",
    PAY_FEE_USER_ACTION: "Pagar uma taxa",
    CONTACT_SUPPORT_USER_ACTION: "Contactar o apoio",
    REQUEST_CALLBACK_USER_ACTION: "Pedir que liguem de volta",
    REPORT_USER_USER_ACTION: "Denunciar alguém",
    BLOCK_USER_USER_ACTION: "Bloquear alguém",
    UNBLOCK_USER_USER_ACTION: "Desbloquear alguém",
    APPEAL_DECISION_USER_ACTION: "Recorrer de uma decisão",
    CREATE_EXPERIMENT_STAFF_ACTION: "Iniciar uma experiência",
    MOVE_EXPERIMENT_STAFF_ACTION: "Alargar ou parar uma experiência",
    ADD_LEAD_STAFF_ACTION: "Adicionar um contacto",
    MOVE_LEAD_STAFF_ACTION: "Fazer avançar um contacto",
    CREATE_CAMPAIGN_STAFF_ACTION: "Preparar uma campanha",
    SEND_CAMPAIGN_STAFF_ACTION: "Enviar uma campanha",
    OPEN_INCIDENT_STAFF_ACTION: "Abrir um incidente",
    UPDATE_INCIDENT_STAFF_ACTION: "Atualizar um incidente",
    VIEW_MARKETPLACE_STAFF_ACTION: "Ver como está o mercado",
    VIEW_MARKETPLACE_JOB_STAFF_ACTION: "Consultar um pedido",
    SIGN_IN_STAFF_ACTION: "Iniciar sessão na consola",
    SIGN_OUT_STAFF_ACTION: "Terminar sessão na consola",
    SET_PASSWORD_STAFF_ACTION: "Definir a palavra-passe da consola",
    UPDATE_STAFF_SETTING_STAFF_ACTION: "Alterar uma definição da consola",
    SEARCH_ACCOUNTS_STAFF_ACTION: "Pesquisar contas",
    VIEW_ACCOUNT_STAFF_ACTION: "Ver uma conta",
    REVEAL_CONTACT_DETAILS_STAFF_ACTION: "Mostrar um número de telefone",
    EDIT_CUSTOMER_SETTING_STAFF_ACTION: "Alterar a definição de um cliente",
    CORRECT_ACCOUNT_DETAILS_STAFF_ACTION: "Corrigir os dados de uma conta",
    CLAIM_CASE_STAFF_ACTION: "Assumir um processo",
    LOG_CALL_STAFF_ACTION: "Registar uma chamada",
    REPLY_TO_CASE_STAFF_ACTION: "Responder a um cliente",
    ADD_CASE_NOTE_STAFF_ACTION: "Adicionar uma nota interna",
    CLOSE_CASE_STAFF_ACTION: "Encerrar um processo",
    REASSIGN_CASE_STAFF_ACTION: "Reatribuir um processo",
    LINK_CASE_CUSTOMER_STAFF_ACTION: "Associar um cliente a um processo",
    START_ON_BEHALF_SESSION_STAFF_ACTION: "Começar a agir em nome de um cliente",
    END_ON_BEHALF_SESSION_STAFF_ACTION: "Deixar de agir em nome de um cliente",
    VIEW_VERIFICATION_STAFF_ACTION: "Ver uma verificação",
    APPROVE_VERIFICATION_STAFF_ACTION: "Aprovar uma verificação",
    REJECT_VERIFICATION_STAFF_ACTION: "Recusar uma verificação",
    VIEW_ID_IMAGES_STAFF_ACTION: "Ver as imagens de identidade",
    APPROVE_PRO_STAFF_ACTION: "Aprovar um profissional",
    REJECT_PRO_STAFF_ACTION: "Recusar um profissional",
    VIEW_PAYMENTS_STAFF_ACTION: "Ver os pagamentos",
    ISSUE_REFUND_STAFF_ACTION: "Emitir um reembolso",
    ISSUE_CREDIT_STAFF_ACTION: "Emitir um crédito",
    WAIVE_FEE_STAFF_ACTION: "Anular uma taxa",
    MARK_PAYMENT_PAID_STAFF_ACTION: "Marcar uma taxa como paga",
    APPROVE_PAYMENT_REQUEST_STAFF_ACTION: "Aprovar uma solicitação",
    REJECT_PAYMENT_REQUEST_STAFF_ACTION: "Recusar uma solicitação",
    SETTLE_REFUND_STAFF_ACTION: "Liquidar um reembolso",
    SET_PLAN_PRICE_STAFF_ACTION: "Definir o preço de um plano",
    CREATE_PROMO_STAFF_ACTION: "Criar uma promoção",
    END_PROMO_STAFF_ACTION: "Terminar uma promoção",
    CREATE_DISCOUNT_STAFF_ACTION: "Criar um desconto",
    END_DISCOUNT_STAFF_ACTION: "Terminar um desconto",
    EXTEND_SUBSCRIPTION_STAFF_ACTION: "Prolongar uma assinatura",
    END_SUBSCRIPTION_STAFF_ACTION: "Terminar uma assinatura",
    RECONCILE_PAYMENTS_STAFF_ACTION: "Reconciliar os pagamentos",
    EXPORT_PAYMENTS_STAFF_ACTION: "Exportar os pagamentos",
    OPEN_SAFETY_REPORT_STAFF_ACTION: "Abrir uma denúncia de segurança",
    ADD_REPORT_EVIDENCE_STAFF_ACTION: "Adicionar provas a uma denúncia",
    SET_REPORT_SEVERITY_STAFF_ACTION: "Definir a gravidade de uma denúncia",
    SUSPEND_PENDING_INVESTIGATION_STAFF_ACTION: "Suspender uma conta enquanto decorre a investigação",
    LIFT_SUSPENSION_STAFF_ACTION: "Levantar uma suspensão",
    ISSUE_VERDICT_STAFF_ACTION: "Emitir um veredicto",
    BAN_PERMANENTLY_STAFF_ACTION: "Banir uma conta definitivamente",
    DECIDE_APPEAL_STAFF_ACTION: "Decidir um recurso",
    REFER_TO_POLICE_STAFF_ACTION: "Encaminhar um processo para a polícia",
    SHARE_DATA_WITH_POLICE_STAFF_ACTION: "Partilhar dados com a polícia",
    PLACE_LEGAL_HOLD_STAFF_ACTION: "Aplicar uma preservação de provas",
    RELEASE_LEGAL_HOLD_STAFF_ACTION: "Levantar uma preservação de provas",
    HIDE_REVIEW_STAFF_ACTION: "Ocultar uma avaliação",
    RESTORE_REVIEW_STAFF_ACTION: "Repor uma avaliação",
    SEND_SMS_STAFF_ACTION: "Enviar um SMS",
    SEND_BULK_SMS_STAFF_ACTION: "Enviar um SMS a muitas pessoas",
    EDIT_SMS_TEMPLATE_STAFF_ACTION: "Alterar um modelo de SMS",
    SET_USER_FEATURE_ENABLEMENT_STAFF_ACTION: "Ativar ou desativar uma funcionalidade de cliente",
    CREATE_RULE_VERSION_STAFF_ACTION: "Alterar uma regra da empresa",
    EDIT_PRICING_STAFF_ACTION: "Alterar os escalões de taxas",
    EDIT_CATEGORIES_STAFF_ACTION: "Alterar os ofícios",
    INVITE_STAFF_STAFF_ACTION: "Convidar um membro da equipa",
    DEACTIVATE_STAFF_STAFF_ACTION: "Desativar um membro da equipa",
    REACTIVATE_STAFF_STAFF_ACTION: "Reativar um membro da equipa",
    END_STAFF_SESSION_STAFF_ACTION: "Terminar as sessões de um membro da equipa",
    REQUEST_PERMISSION_STAFF_ACTION: "Pedir uma permissão",
    DECIDE_PERMISSION_REQUEST_STAFF_ACTION: "Responder a um pedido de permissão",
    UPDATE_ACTION_ENABLEMENT_STAFF_ACTION: "Alterar a ativação de uma ação",
    REQUEST_TIME_OFF_STAFF_ACTION: "Pedir férias",
    DECIDE_TIME_OFF_STAFF_ACTION: "Decidir um pedido de férias",
    SET_EMPLOYMENT_STAFF_ACTION: "Editar um processo de emprego",
    OPEN_JOB_STAFF_ACTION: "Abrir uma vaga",
    EDIT_JOB_STAFF_ACTION: "Editar uma vaga",
    MOVE_CANDIDATE_STAFF_ACTION: "Avançar um candidato",
    OPEN_PAYROLL_STAFF_ACTION: "Abrir um mês de salários",
    EDIT_PAYROLL_LINE_STAFF_ACTION: "Reter ou libertar uma linha de salário",
    CLOSE_PAYROLL_STAFF_ACTION: "Fechar um mês de salários",
    OPEN_REVIEW_CYCLE_STAFF_ACTION: "Abrir um ciclo de avaliação",
    WRITE_REVIEW_STAFF_ACTION: "Escrever uma avaliação",
    EDIT_COURSE_STAFF_ACTION: "Adicionar ou alterar uma formação",
    ENROL_IN_COURSE_STAFF_ACTION: "Inscrever-se numa formação",
    CREATE_TEAM_STAFF_ACTION: "Criar uma equipa",
    EDIT_TEAM_STAFF_ACTION: "Editar uma equipa",
    SET_TEAM_MEMBERSHIP_STAFF_ACTION: "Definir quem está na equipa",
    CREATE_ROLE_STAFF_ACTION: "Criar uma função",
    EDIT_ROLE_STAFF_ACTION: "Alterar uma função",
    SET_STAFF_PERMISSION_STAFF_ACTION: "Conceder ou retirar uma permissão",
    SET_STAFF_FEATURE_ENABLEMENT_STAFF_ACTION: "Conceder ou retirar uma funcionalidade",
    ASSIGN_ROLE_STAFF_ACTION: "Atribuir uma função",
    REMOVE_ROLE_STAFF_ACTION: "Retirar uma função",
    VIEW_AUDIT_LOG_STAFF_ACTION: "Consultar o registo de auditoria",
    VIEW_SENSITIVE_AUDIT_VALUES_STAFF_ACTION: "Ver os valores sensíveis da auditoria",
    VIEW_HEALTH_DASHBOARD_STAFF_ACTION: "Ver o painel de saúde",
    EXPIRE_JOB_SYSTEM_ACTION: "Expirar um pedido sem resposta",
    EXPIRE_QUOTE_SYSTEM_ACTION: "Expirar um orçamento",
    CLOSE_OTHER_QUOTES_SYSTEM_ACTION: "Fechar os outros orçamentos",
    OPEN_CONVERSATION_ON_QUOTE_SYSTEM_ACTION: "Abrir uma conversa sobre um orçamento",
    NOTIFY_USER_SYSTEM_ACTION: "Enviar uma notificação",
    NOTIFY_NEW_LEAD_SYSTEM_ACTION: "Avisar um profissional de uma nova oportunidade",
    SEND_LEAD_SMS_SYSTEM_ACTION: "Enviar uma oportunidade por SMS",
    NOTIFY_JOB_REMINDER_SYSTEM_ACTION: "Enviar um lembrete de pedido",
    CONFIRM_FEE_PAYMENT_SYSTEM_ACTION: "Confirmar o pagamento de uma taxa",
    FAIL_FEE_PAYMENT_SYSTEM_ACTION: "Registar o pagamento falhado de uma taxa",
    ACTIVATE_SUBSCRIPTION_SYSTEM_ACTION: "Ativar uma assinatura",
    SUSPEND_SUBSCRIPTION_SYSTEM_ACTION: "Suspender uma assinatura",
    RENEW_SUBSCRIPTION_SYSTEM_ACTION: "Renovar uma assinatura",
    EXPIRE_SUBSCRIPTION_SYSTEM_ACTION: "Terminar uma assinatura caducada",
    REMIND_SUBSCRIPTION_EXPIRY_SYSTEM_ACTION: "Lembrar um profissional de que o plano está a terminar",
    EXPIRE_SETTING_VALUE_SYSTEM_ACTION: "Expirar o valor de uma definição",
    DELETE_ID_IMAGES_SYSTEM_ACTION: "Eliminar as imagens de identidade",
    FLAG_BANNED_DOCUMENT_SYSTEM_ACTION: "Sinalizar um documento banido",
    SUSPEND_ON_CRITICAL_REPORT_SYSTEM_ACTION: "Suspender após uma denúncia crítica",
  },
  /** The settings a person chooses for themselves, by settingId. */
  settings: {
    THEME_USER_SETTING: "Tema",
    COLOR_VIBE_USER_SETTING: "Cor",
    LANGUAGE_USER_SETTING: "Idioma",
    LOW_DATA_MODE_USER_SETTING: "Modo de dados reduzidos",
    NEW_LEAD_NOTIFICATION_USER_SETTING: "Avisar-me de novas oportunidades",
    QUOTE_RECEIVED_NOTIFICATION_USER_SETTING: "Avisar-me quando chegar um orçamento",
    NEW_LEAD_SMS_USER_SETTING: "Enviar as novas oportunidades por SMS",
    QUOTE_RECEIVED_SMS_USER_SETTING: "Enviar um orçamento por SMS",
    LEAD_TRADES_USER_SETTING: "Ofícios para os quais quero oportunidades",
    LEAD_SERVICE_AREA_USER_SETTING: "Onde trabalho",
    LEAD_RADIUS_USER_SETTING: "Até que distância me desloco",
    LEAD_DAYS_USER_SETTING: "Dias em que aceito trabalho",
    URGENT_JOBS_USER_SETTING: "Pedidos urgentes",
    CONSOLE_THEME_STAFF_SETTING: "Tema da consola",
    CONSOLE_LANGUAGE_STAFF_SETTING: "Idioma da consola",
  },
  /** The grid's section titles. */
  categories: {
    appearance: "Aspeto",
    notifications: "Notificações",
    leads: "Oportunidades",
    discovery: "Pesquisa",
    jobs: "Pedidos",
    profile: "Perfil",
    accounts: "Contas",
    support: "Processos",
    onBehalf: "Em nome de um cliente",
    onboarding: "Verificação",
    payments: "Pagamentos",
    safety: "Confiança e segurança",
    messaging: "Mensagens",
    configuration: "Configuração",
    staff: "Equipa e acessos",
    audit: "Auditoria",
  },
};
